export const customZhCn = {
    "gui.libraryTags.dingdangcode": "叮当码",
};
